import React from 'react';

export default function IllustrationsIcon({
  className,
  onClick,
  fill,
}: {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  fill?: string;
}) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill || '#6C757D'}
    >
      <path d="M7.06102 22C8.58402 22 9.90102 21.457 10.971 20.387C12.094 19.264 12.678 17.533 12.522 15.893L21.086 7.32903C22.303 6.11203 22.303 4.13403 21.084 2.91503C19.906 1.73503 17.85 1.73503 16.672 2.91503L7.78802 11.799C5.87502 11.968 3.98102 13.32 3.98102 15.718C3.98102 16.021 4.00202 16.306 4.02302 16.578C4.10302 17.609 4.13202 17.996 2.55202 18.786C2.23602 18.944 2.02702 19.258 2.00202 19.61C1.97702 19.962 2.14002 20.301 2.43002 20.503C2.52002 20.563 4.62302 22 7.06102 22C7.06002 22 7.06002 22 7.06102 22ZM18.086 4.32803C18.51 3.90403 19.244 3.90203 19.672 4.33003C20.109 4.76703 20.109 5.47703 19.672 5.91403L12 13.586L10.414 12L18.086 4.32803ZM6.01802 16.423C6.00002 16.199 5.98102 15.965 5.98102 15.717C5.98102 14.172 7.42602 13.764 8.19102 13.764C8.54702 13.764 8.89002 13.837 9.15502 13.97C10.1 14.445 10.415 15.263 10.512 15.866C10.689 16.956 10.295 18.234 9.55602 18.973C8.86502 19.664 8.04902 20 7.06102 20H7.06002C6.31002 20 5.58102 19.804 4.98602 19.573C6.06802 18.6 6.10702 17.584 6.01802 16.423Z" />
    </svg>
  );
}
